/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable functional/prefer-readonly-type */
import React, { ChangeEvent, useEffect } from 'react'
import {
  IconButton,
  ListItem,
  ListItemText,
  CircularProgress,
  Grid,
  Typography,
  Divider,
  TextField,
  Button,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Checkbox,
  Badge,
  Tooltip,
  Box,
  Collapse,
  Stack,
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import EditIcon from '@mui/icons-material/Edit'
import { ErrorBoundary } from 'react-error-boundary'
import ErrorFallback from '~/components/ErrorFallback'
import {
  getInfoDispatch,
  getOccurrenceAllService,
  getTimeLineDispatch,
} from '~/features/Occurrence/services/index'
import { useHookstate } from '@hookstate/core'
import IType from '~/features/Type/interfaces/IType'
import ISubtype from '~/features/Subtype/interfaces/ISubtype'
import ICity from '~/features/City/interfaces/ICity'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useLang } from '~/hooks/useLang'
import useOccurrenceState from '~/features/Occurrence/stores/OccurrenceState'
import useOccurrenceCommentState from '~/features/Occurrence/stores/OccurrenceCommentState'
import useSystemState from '~/features/System/stores/SystemState'
import TypeSelectField from '~/features/Entry/components/TypeSelectField'
import SubtypeSelectField from '~/features/Entry/components/SubtypeSelectField'
import FilterAutocompleteDispatchsGroups from '~/components/FilterAutocompleteDispatchsGroups'
import FilterSelectPeriod from '~/components/FilterAutocompletePeriod'
import InputMask from 'react-input-mask'
import { getOnlyNumbersInString } from '~/utils/strings'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import FilterAutocompleteCity from '~/components/FilterSelectAutocompleteCity'
import FilterAutocompleteDistrict from '~/components/FilterSelectAutocompleteDistrict'
import FilterAutocompleteStatus from '~/components/FilterAutoCompleteStatus'
import { TimeLineOccurrenceDispatchProps } from '../../interfaces/IDispatchOccurrence'
import TimelineDispatchesOccurrence from './components/timeLineDispatchesOccurrence'
import InputOccurrenceNumber from '~/components/InputOccurrenceNumber'
import FilterSwitch from '~/components/FilterSwitch'
import FilterKeyword from '~/features/Report/components/FilterKeyword'

interface Dispatches {
  readonly id: number
  readonly code: string | null
  readonly status: {
    readonly id: number
    readonly name: string | null
    readonly acronym: string | null
  }
}
interface OccurrenceListProps {
  readonly id: number
  readonly location: string
  readonly type: IType
  readonly subtype: ISubtype
  readonly city: ICity
  readonly name: string
  readonly phone: string
  readonly calls: number
  readonly dispatches: readonly Dispatches[]
}

interface filtersProps {
  readonly hide: boolean
  readonly content: Array<any>
  readonly fields: {
    readonly id: string | null
    readonly name: string | null
    readonly phone: string | null
    readonly code: string | null
    readonly type_id: number | null
    readonly subtype_id: number | null
    readonly city_id: number | null
    readonly district_id: number | null
    readonly location: string | null
    readonly created_at: Array<string> | null
  }
}

const filtersDefault: filtersProps = {
  hide: true,
  content: [],
  fields: {
    id: null,
    name: null,
    phone: null,
    code: null,
    type_id: null,
    subtype_id: null,
    city_id: null,
    district_id: null,
    location: null,
    created_at: [],
  },
}

interface dispatchDestinationProps {
  readonly id: number
  readonly code: string
}

// eslint-disable-next-line max-lines-per-function
export default function OccurrenceList() {
  const { translate } = useLang()
  const {
    syncOccurrenceEditAttendent,
    statusDispatchRelated,
    occurrence,
    dispatchesOccurrence,
  } = useOccurrenceState()
  const { id: occurrencId } = occurrence()
  const { windowManager, getStatusColors } = useSystemState()
  const { syncPreviousComments } = useOccurrenceCommentState()
  // const occurrences = useHookstate<readonly OccurrenceListProps[]>([])

  const filters = useHookstate(filtersDefault)
  const typeName = useHookstate('')
  const subTypeName = useHookstate<string | null>('')
  const [open, setOpen] = React.useState(false)
  const [code, setCode] = React.useState('')
  const [agency, setAgency] = React.useState('')
  const [dispatchGroup, setDispatchGroup] = React.useState('')
  const [type, setType] = React.useState('')
  const [subtype, setSubtype] = React.useState('')
  const [status, setStatus] = React.useState('')
  const startDate = useHookstate<string | null>(null)
  const finishDate = useHookstate<string | null>(null)
  const period = useHookstate('')
  const groupIds = useHookstate<readonly number[]>([])
  const checked = useHookstate<boolean>(false)
  const dispatchDestination = useHookstate<dispatchDestinationProps | null>(
    null
  )
  const loading = useHookstate(false)
  const maskCelPhone = '(99) 99999-9999'
  const maskPhone = '(99) 9999-9999'
  const mask = useHookstate(maskCelPhone)
  const phoneValue =
    filters.fields.phone.get() == null ? '' : `${filters.fields.phone.get()}`
  const checkedCreatedByMe = useHookstate<boolean>(false)
  const statusId = useHookstate<number | null>(null)
  const dispatchIdSelected = useHookstate(null)
  const timeLine = useHookstate<TimeLineOccurrenceDispatchProps[]>([])
  const { screen } = window
  const comments = useHookstate<string>('')
  const [filtersOpen, setFiltersOpen] = React.useState(true)
  const includeAllWords = useHookstate<boolean>(false)
  const keyWordFormated = useHookstate<string[]>([])
  const Input = InputMask as any

  useEffect(() => {
    loading.set(true)
    dispatchesOccurrence().set([])
    nextData()
  }, [])

  const nextData = async (reset = false) => {
    makeCommentsRequest()
    const pageQuery = reset
      ? 0
      : Math.floor(dispatchesOccurrence().get().length / 10)
    const response = await getOccurrenceAllService({
      keyWords: keyWordFormated.get(),
      includeAllWords: includeAllWords.get(),
      page: pageQuery,
      limit: 10,
      filters: filters.content.get(),
      dispatchGroupIds: groupIds.get(),
      visibleDispatchGroups: checked.get(),
      createdByMe: checkedCreatedByMe.get(),
      statusId: statusId.get(),
    })
    if (reset) {
      dispatchesOccurrence().set(response.results)
    } else {
      dispatchesOccurrence().merge(response.results)
    }
    loading.set(false)
  }

  const onClick = (params) => {
    syncOccurrenceEditAttendent(params.id)
    syncPreviousComments(params.id)
    windowManager().occurrence.open.set(true)
  }

  const actionFilter = () => {
    loading.set(true)
    filters.content.set([])
    Object.keys(filters.fields.value).map((field) => {
      if (
        filters.fields.value[field] != null &&
        filters.fields.value[field] != ''
      ) {
        filters.content.merge([
          {
            field: field,
            operator: field === 'created_at' ? 'between' : 'contains',
            value: filters.fields.value[field] ?? null,
          },
        ])
      }
    })
    nextData(true)
    filters.hide.set(true)
  }

  const handleClickOpen = (code) => {
    getInfoDispatch({ code: code })
      .then((response) => {
        dispatchDestination.set(
          response?.data?.unified?.dispatch_destination
            ? response?.data?.unified?.dispatch_destination
            : null
        )
        setCode(code)
        setAgency(` - ${response.data.agency?.name}`)
        setDispatchGroup(`${response.data.dispatch_group?.name}`)
        setType(`${response.data.type?.name}`)
        setSubtype(
          response.data.subtype ? `- ${response.data.subtype?.name}` : ''
        )
        setStatus(`[${response.data.status?.acronym}]`)
        dispatchIdSelected.set(response.data.id)
        setOpen(true)
      })
      .finally(() => {
        getTimeLineDispatch({ dispatchId: dispatchIdSelected.get() }).then(
          (response) => {
            timeLine.set(response.data)
          }
        )
      })
  }

  const handleClose = () => {
    setOpen(false)
  }

  const clearFilters = () => {
    loading.set(true)
    filters.content.set([])
    filters.fields.id.set(null)
    filters.fields.name.set(null)
    filters.fields.phone.set(null)
    filters.fields.code.set(null)
    filters.fields.type_id.set(null)
    filters.fields.subtype_id.set(null)
    filters.fields.city_id.set(null)
    filters.fields.district_id.set(null)
    filters.fields.location.set(null)
    filters.fields.created_at.set([])
    period.set('')
    startDate.set(null)
    finishDate.set(null)
    groupIds.set([])
    statusId.set(null)
    checked.set(false)
    checkedCreatedByMe.set(false)
    comments.set('')
    includeAllWords.set(false)
    keyWordFormated.set([])

    // occurrences.set([])
    dispatchesOccurrence().set([])
    nextData()
  }

  React.useEffect(() => {
    if (phoneValue.length <= 9) {
      mask.set(maskCelPhone)
    }
  }, [phoneValue])

  const defineMask = (number) => {
    if (number <= 10) {
      mask.set(maskPhone)
    } else {
      mask.set(maskCelPhone)
    }
  }

  const makeCommentsRequest = () => {
    if (comments.get()) {
      const wordsFormatedToSend = comments.get()?.replace(/\s/g, '').split(';')
      keyWordFormated.set(
        wordsFormatedToSend?.length ? wordsFormatedToSend : []
      )
    } else {
      keyWordFormated.set([]) // Adicionado para resetar quando comments estiver vazio
    }
  }

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Grid container spacing={2}>
        <Grid container paddingX={1} paddingTop={1}>
          <Grid item xs={12}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              paddingX={2}
              pb={1}
            >
              <Typography
                variant="h6"
                component="h2"
                sx={{ flexGrow: 1, fontSize: '1rem', fontWeight: 400 }}
              >
                {translate('Filters')}
              </Typography>
              <Tooltip
                title={
                  !filters.hide.get() ? 'Exibir os filtros' : 'Ocultar filtros'
                }
              >
                <IconButton
                  onClick={() => {
                    const newOpen = !filtersOpen
                    setFiltersOpen(newOpen)
                    filters.hide.set(newOpen)
                  }}
                  size="small"
                  sx={{ ml: 1 }}
                >
                  <Badge
                    badgeContent={
                      (() => {
                        let count = 0
                        Object.keys(filters.fields.value).forEach((field) => {
                          const value = filters.fields.value[field]
                          if (field === 'created_at') {
                            if (Array.isArray(value) && value.length > 0) count++
                          } else if (value != null && value !== '') {
                            count++
                          }
                        })
                        if (groupIds.get().length > 0) count++
                        if (statusId.get() != null) count++
                        if (checkedCreatedByMe.get()) count++
                        if (checked.get()) count++
                        if (comments.get().trim() !== '') count++
                        return count > 0 ? count : 0
                      })()
                    }
                    color="primary"
                    sx={{
                      '& .MuiBadge-badge': {
                        fontSize: '0.6rem',
                        minWidth: '16px',
                        height: '16px',
                      },
                    }}
                  >
                    {filtersOpen ? <ExpandLess /> : <ExpandMore />}
                  </Badge>
                </IconButton>
              </Tooltip>
            </Stack>
          </Grid>
          <Grid item xs={12} paddingX={1} paddingBottom={1}>
            <Collapse in={filtersOpen}>
              <Grid container>
                <FilterSelectPeriod
                  // disabled={lockFields.get()}
                  xsDateBetween={3.9}
                  xsPeriod={3.9231}
                  onStartDateChange={(value) => {
                    startDate.set(value?.toJSON() ?? null)
                    if (startDate.get() != null) {
                      filters.fields.created_at[0]?.set(startDate.get())
                    }
                  }}
                  onFinishDateChange={(value) => {
                    finishDate.set(value?.toJSON() ?? null)
                    if (finishDate.get() != null) {
                      filters.fields.created_at[1]?.set(finishDate.get())
                    }
                  }}
                  onPeriodChange={(value) => {
                    period.set(value)
                  }}
                  period={period.get()}
                />
              </Grid>
              <Grid container xs={12} direction="row" spacing={1} padding={1}>
                <Grid item xs={4} spacing={1}>
                  <InputOccurrenceNumber
                    occurrence={filters.fields.id}
                    onOccurrenceChange={(
                      event: ChangeEvent<HTMLInputElement>
                    ) => {
                      filters.fields.id.set(event.target.value)
                    }}
                  />
                </Grid>
                <Grid item xs={4} spacing={1}>
                  <TextField
                    fullWidth
                    label={translate('Nº Occurrence')}
                    size="small"
                    value={filters.fields.code.get() ?? ''}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                      filters.fields.code.set(event.target.value)
                    }}
                  />
                </Grid>
                <Grid item xs={4} spacing={1}>
                  <FilterAutocompleteDispatchsGroups
                    dispatcheGroups={groupIds.get() ?? undefined}
                    onGroupDispatchChange={(group) => {
                      groupIds.set(group)
                    }}
                  />
                </Grid>
                <Grid item xs={4} spacing={1}>
                  <TypeSelectField
                    readonly={windowManager()['entry'].readonly.value}
                    isValid={true}
                    typeId={filters.fields.type_id}
                    typeName={typeName}
                    isActive={true}
                  />
                </Grid>
                <Grid item xs={4} spacing={1}>
                  <SubtypeSelectField
                    readonly={windowManager()['entry'].readonly.value}
                    isValid={Boolean(filters.fields.type_id)}
                    typeId={filters.fields.type_id}
                    subtypeId={filters.fields.subtype_id}
                    subTypeName={subTypeName}
                  />
                </Grid>
                <Grid item xs={4} spacing={1}>
                  <FilterAutocompleteStatus
                    onStatusChange={(status) => {
                      statusId?.set(status)
                    }}
                    statusId={statusId.get()}
                  />
                </Grid>
                <Grid item xs={4} spacing={1}>
                  <TextField
                    fullWidth
                    label={translate('Requester')}
                    size="small"
                    value={filters.fields.name.get() ?? ''}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                      filters.fields.name.set(event.target.value)
                    }}
                  />
                </Grid>
                <Grid item xs={4} spacing={1}>
                  <Input
                    mask={mask.get()}
                    value={phoneValue}
                    onBlur={() => defineMask(phoneValue.length)}
                    maskChar=""
                    onChange={(changeEvent: ChangeEvent<HTMLInputElement>) => {
                      filters.fields.phone.set(
                        getOnlyNumbersInString(changeEvent.target.value)
                      )
                    }}
                  >
                    <TextField
                      fullWidth
                      label={translate('Phone')}
                      size="small"
                      value={filters.fields.phone.get() ?? ''}
                      // onChange={(event: ChangeEvent<HTMLInputElement>) => { filters.fields.phone.set(event.target.value) }}
                    />
                  </Input>
                </Grid>
                <Grid item xs={4} spacing={1}>
                  <TextField
                    fullWidth
                    label={`${translate('Location')}`}
                    size="small"
                    value={filters.fields.location.get() ?? ''}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                      filters.fields.location.set(event.target.value)
                    }}
                  />
                </Grid>
                <Grid item xs={4} gap={0.2} flexDirection={'column'}>
                  <FilterAutocompleteCity
                    onCityChange={(city) => {
                      filters.fields.city_id?.set(city)
                    }}
                    cityId={filters.fields.city_id?.get()}
                  />
                  <FormControlLabel
                    // Remove margem padrão
                    control={
                      <Checkbox
                        checked={checkedCreatedByMe.get()}
                        onChange={() => {
                          checkedCreatedByMe.set(!checkedCreatedByMe.get())
                        }}
                        size="medium"
                      />
                    }
                    label={
                      <Typography
                        variant="body2"
                        fontSize="1rem"
                        sx={{ whiteSpace: 'nowrap' }}
                      >
                        {translate('Occurrences created by me')}
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    sx={{ mt: 0 }} // Remove margem padrão
                    control={
                      <Checkbox
                        checked={checked.get()}
                        onChange={() => {
                          checked.set(!checked.get())
                        }}
                        size="medium"
                      />
                    }
                    label={
                      <Typography
                        variant="body2"
                        fontSize="1rem"
                        sx={{ whiteSpace: 'nowrap' }}
                      >
                        {translate(
                          'Only dispatch groups assigned to the station'
                        )}
                      </Typography>
                    }
                  />
                </Grid>
                <Grid item xs={4} spacing={1}>
                  <FilterAutocompleteDistrict
                    onDistrictChange={(district) => {
                      filters.fields.district_id?.set(district)
                    }}
                    districtId={filters.fields.district_id}
                    cityId={filters.fields.city_id.get()}
                  />
                </Grid>
                <Grid
                  item
                  xs={4}
                  sx={{ pl: 1, pt: 1, flexDirection: 'column' }}
                >
                  <FilterKeyword keyWords={comments} />
                  {comments.get().trim() !== '' && (
                    <Box sx={{ paddingTop: 1, paddingLeft: 1 }}>
                      <FilterSwitch
                        label={translate('Contain all keywords')}
                        onCheckedChange={() => {
                          includeAllWords?.set(!includeAllWords.value)
                        }}
                        checked={includeAllWords?.get()}
                        tooltip={'All words must exist in the comment'}
                        size="small"
                      />
                    </Box>
                  )}
                </Grid>
                <Grid
                  item
                  width={'100%'}
                  display={'flex'}
                  flexDirection={'row'}
                  alignItems={'center'}
                  justifyContent={'flex-end'}
                  gap={2}
                >
                  <Grid item spacing={1}>
                    <Button
                      variant="text"
                      onClick={() => clearFilters()}
                      sx={{
                        height: '40px',
                        textTransform: 'none',
                        textDecorationLine: 'underline',
                        color: 'text.primary',
                        ':hover': {
                          bgcolor: 'transparent',
                          color: 'primary.main',
                        },
                      }}
                    >
                      {translate('Clear Filters')}
                    </Button>
                  </Grid>
                  <Grid item spacing={1}>
                    <Tooltip title={translate('Search')} placement="bottom">
                      <IconButton
                        onClick={() => actionFilter()}
                        title={translate('Search')}
                      >
                        <SearchIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
              </Grid>
              <Divider />
            </Collapse>
          </Grid>
        </Grid>

        <Grid container paddingX={1} paddingY={0}>
          <Grid item xs={12}>
            <InfiniteScroll
              dataLength={dispatchesOccurrence().value.length}
              // dataLength={dispatchesOccurrence().value.length}
              next={nextData}
              hasMore={
                dispatchesOccurrence().value.length % 10 == 0 &&
                dispatchesOccurrence().value.length != 0
                // dispatchesOccurrence().value.length % 10 == 0 &&
                // dispatchesOccurrence().value.length != 0
              }
              height={
                filters.hide.get() ? screen.height / 2.5 : screen.height / 1.2
              }
              loader={false}
            >
              {dispatchesOccurrence().value.length === 0 && !loading.get() ? (
                // {dispatchesOccurrence().value.length === 0 && !loading.get() ? (
                <Grid
                  xs={12}
                  style={{
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Typography>{translate('No Occurrences')}</Typography>
                </Grid>
              ) : dispatchesOccurrence().value.length != 0 && !loading.get() ? (
                dispatchesOccurrence()
                  .get()
                  .map((items) => (
                    // ): dispatchesOccurrence().value.length != 0 && !loading.get() ? (
                    //   dispatchesOccurrence().get().map((items) => (
                    <>
                      <ListItem
                        key={items.id}
                        secondaryAction={
                          <Tooltip
                            title="Editar"
                            componentsProps={{
                              tooltip: {
                                sx: { fontSize: '14px', padding: '6px 10px' },
                              },
                            }}
                          >
                            <IconButton
                              aria-label="comment"
                              onClick={() => onClick(items)}
                              disabled={Boolean(
                                items?.dispatches?.find(
                                  (element) => element.status.acronym === 'UN'
                                )
                              )}
                            >
                              <EditIcon />
                            </IconButton>
                          </Tooltip>
                        }
                      >
                        <ListItemText
                          primary={`OC: ${items?.id} - ${
                            items?.type?.name ? items?.type?.name : ''
                          } ${
                            items?.subtype?.name ? items?.subtype?.name : ''
                          }  ${
                            items?.calls
                              ? items?.calls > 1
                                ? `| ${translate('RepeatedCall')}`
                                : ''
                              : ''
                          }`}
                          secondary={`${translate('Location')}: ${
                            items?.location ? items?.location : ''
                          } ${
                            items?.city?.name ? `- ${items?.city?.name}` : ''
                          } ${
                            items?.name ? `| Solicitante: ${items?.name}` : ''
                          } ${
                            items?.phone ? `| Telefone: ${items?.phone}` : ''
                          }`}
                        />
                      </ListItem>
                      <Grid
                        item
                        sx={{
                          display: 'flex',
                          flexWrap: 'wrap',
                        }}
                      >
                        {items.dispatches.map((element) => (
                          <Chip
                            key={element.id}
                            label={element.code}
                            onClick={() => handleClickOpen(element.code)}
                            sx={{
                              margin: '16px 0 0 16px',
                              backgroundColor: getStatusColors(
                                element.status?.id
                              ).main,
                              color: getStatusColors(element.status?.id)
                                .contrastText,
                              '&:hover': {
                                backgroundColor: getStatusColors(
                                  element.status?.id
                                ).dark,
                                color: getStatusColors(element.status?.id)
                                  .contrastText,
                              },
                            }}
                          />
                        ))}
                      </Grid>
                      <Divider sx={{ marginTop: 2 }} />
                    </>
                  ))
              ) : (
                <Grid
                  container
                  xs={12}
                  item
                  display={'flex'}
                  marginTop={'30%'}
                  flexDirection={'column'}
                  justifyContent={'center'}
                  alignItems={'center'}
                >
                  <CircularProgress />
                </Grid>
              )}
            </InfiniteScroll>
          </Grid>
        </Grid>
        <Dialog
          maxWidth={'xs'}
          fullWidth={true}
          open={open}
          onClose={handleClose}
        >
          <DialogTitle>
            {translate('Dispatch')} -{code} -{status}
            <Typography variant="subtitle2">
              {dispatchGroup} {agency}
            </Typography>
            <Typography variant="subtitle2">
              {type} {subtype}
            </Typography>
          </DialogTitle>
          <DialogContent>
            {dispatchDestination.get() ? (
              <>
                <br />
                <Typography>
                  {translate('Unified')} {translate('With')}:{' '}
                  <Chip label={dispatchDestination.get()?.code} />
                </Typography>
              </>
            ) : (
              false
            )}

            <TimelineDispatchesOccurrence timeLinePoint={timeLine} />
          </DialogContent>
          <DialogActions>
            <Button variant="contained" onClick={handleClose}>
              {translate('Close')}
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    </ErrorBoundary>
  )
}
